import React from "react";
import { Routes, Route } from "react-router-dom";
import { ConfigProvider } from "antd";
import { ProtectedRoute } from "./layout/routes/ProtectedRoutes";
import { PublicRoute } from "./layout/routes/PublicRoutes";
import { MidRoute } from "./layout/routes/MidRoutes";
import { config } from "./utils/theme/config";
import { AppPages } from "./layout/routes/Routes";
import AuthProvider from "./context/AuthProvider";
import QuickbooksProvider from "./context/QuickbooksProvider";
import DataProvider from "./context/DataProvider";
import LayoutProvider from "./context/LayoutProvider";
import "./globals.css";
import "./assets/sass/main.scss";
import { NotificationProvider } from "./context/NotificationProvider";
import { GoogleOAuthProvider } from "@react-oauth/google";

const App: React.FC = () => {
  console.log(process.env.REACT_APP_GOOGLE_CLIENT_ID);
  return (
    <AuthProvider>
      <GoogleOAuthProvider
        clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ""}
      >
        <NotificationProvider>
          <QuickbooksProvider>
            <DataProvider>
              <LayoutProvider>
                <ConfigProvider {...config}>
                  <Routes>
                    {AppPages?.map((route, index) => (
                      <Route
                        key={index}
                        path={route.path}
                        element={
                          route.protected ? (
                            <>
                              {route.isProtectedMiddleware ? (
                                <MidRoute>{route.component}</MidRoute>
                              ) : (
                                <ProtectedRoute>
                                  {route.component}
                                </ProtectedRoute>
                              )}
                            </>
                          ) : route.isMiddleware ? (
                            <MidRoute>{route.component}</MidRoute>
                          ) : (
                            <PublicRoute>{route.component}</PublicRoute>
                          )
                        }
                      />
                    ))}
                  </Routes>
                </ConfigProvider>
              </LayoutProvider>
            </DataProvider>
          </QuickbooksProvider>
        </NotificationProvider>
      </GoogleOAuthProvider>
    </AuthProvider>
  );
};

export default App;
